import { Progress } from "@/components/ui/progress";
import { useI18n } from "@/context/I18nContext";
import { Crown } from "lucide-react";

function Meter({ label, used, limit, unlimitedLabel }) {
  const unlimited = limit === null || limit === undefined;
  const pct = unlimited ? 0 : Math.min(100, (used / limit) * 100);
  const danger = !unlimited && used >= limit;
  return (
    <div data-testid="usage-meter">
      <div className="flex items-center justify-between text-sm mb-1.5">
        <span className="text-muted-foreground">{label}</span>
        <span className={`font-mono tabular-nums ${danger ? "text-rose-300" : "text-foreground"}`}>
          {used}{unlimited ? "" : ` / ${limit}`}
          {unlimited && <span className="text-cyan-300"> {unlimitedLabel}</span>}
        </span>
      </div>
      {!unlimited && (
        <Progress value={pct} className="h-2 bg-white/6" />
      )}
    </div>
  );
}

export function UsageCard({ usage, onUpgrade }) {
  const { t } = useI18n();
  if (!usage) return null;
  return (
    <div className="card-base p-5">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-display font-semibold">{t("usage.planUsage")}</h3>
        {usage.is_premium ? (
          <span className="inline-flex items-center gap-1 text-xs rounded-full px-2.5 py-1 bg-cyan-400/10 text-cyan-200 border border-cyan-400/25">
            <Crown style={{ width: 13, height: 13 }} /> {t("common.premium")}
          </span>
        ) : (
          <span className="text-xs rounded-full px-2.5 py-1 bg-white/5 text-muted-foreground border border-white/10">{t("common.free")}</span>
        )}
      </div>
      <div className="space-y-4">
        <Meter label={t("usage.receiptScans")} used={usage.scans_used} limit={usage.scans_limit} unlimitedLabel={t("usage.unlimited")} />
        <Meter label={t("usage.subscriptions")} used={usage.subscriptions_used} limit={usage.subscriptions_limit} unlimitedLabel={t("usage.unlimited")} />
      </div>
      {!usage.is_premium && (
        <button onClick={onUpgrade} data-testid="usage-upgrade-button" className="mt-4 w-full text-sm rounded-lg border border-cyan-400/30 text-cyan-200 py-2 hover:bg-cyan-400/10 transition-colors">
          {t("usage.upgradeUnlimited")}
        </button>
      )}
    </div>
  );
}
